/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */
import 'gmf/controllers/mobile.scss';
import './sass/mobile.scss';

import angular from 'angular';
import olSourceVector from 'ol/source/Vector.js';
import olLayerVector from 'ol/layer/Vector.js';
import olCollection from 'ol/Collection.js';

import gmfControllersAbstractMobileController, {
  AbstractMobileController,
} from 'gmf/controllers/AbstractMobileController.js';
import gmfEditingModule from 'gmf/editing/module.js';

import gr_mapfish3GeofunctionsComponent from '../geofunctions/component.js';
import gr_mapfish3Base from '../gr_mapfish3module.js';

/**
 * @private
 */
class Controller extends AbstractMobileController {
  /**
   * @param {angular.IScope} $scope Scope.
   * @param {angular.auto.IInjectorService} $injector Main injector.
   * @ngInject
   */
  constructor($scope, $injector) {
    super($scope, $injector);

    // handle icon change on geofunction tool button when selected geometry type change
    this.geofunctionsiconcallback = (value) => {
      $('.geofunctions-tool').removeClass('geofunctions-point');
      $('.geofunctions-tool').removeClass('geofunctions-line');
      $('.geofunctions-tool').removeClass('geofunctions-polygon');
      if (value) {
        $('.geofunctions-tool').addClass(`geofunctions-${value}`);
      }
    };

    // watch activation/deactivation of geofunction tool
    this.geofunctionactive = false;
    $scope.$watch(
      () => this.geofunctionsPanelActive,
      (newVal) => {
        this.geofunctionactive = newVal;
        $scope.$broadcast('geofunctionsPanelChange');
        if (!newVal) {
          this.geofunctionsiconcallback(null);
        }
      }
    );

    /**
     * @type {import("ol/layer/Vector.js").default}
     */
    this.editFeatureVectorLayer = new olLayerVector({
      source: new olSourceVector({
        wrapX: false,
        features: new olCollection(),
      }),
    });
    this.editFeatureVectorLayer.setMap(this.map);
  }
}

/**
 * @hidden
 */
const gr_mapfish3Module = angular.module('Appmobile', [gr_mapfish3Base.name, gmfControllersAbstractMobileController.name, gr_mapfish3GeofunctionsComponent.name, gmfEditingModule.name]);

gr_mapfish3Module.controller('MobileController', Controller);

gr_mapfish3Module.value('ngeoSnappingTolerance', 20);
gr_mapfish3Module.value('ngeoSnappingSource', new olSourceVector());

gr_mapfish3Module.constant('obj', 'none');

export default gr_mapfish3Module;
